module.exports = __webpack_public_path__ + "media/images/marketing/step1-cc3ec54fe37cacf2424ba0d3e7f637d457d0ad13fd511a4464053dbbc6470630.jpg";